import { useEffect, useState } from "react";
import api from "../services/api";
import { useParams, useNavigate } from "react-router-dom";
import "../css/Seguimiento.css";
import RenderField from "./dynamicsFields/RenderField.js";
import { usePatologia } from "../context/PatologiaContext.js";
import Swal from "sweetalert2";

const Seguimiento = () => {
  // Estados y constantes faltantes para evitar errores de no definido
  const [datosCabeceraEdicion, setDatosCabeceraEdicion] = useState({ edad: '', sexo: '', genero: '', conviviente: false });
  const [tiposRelacion, setTiposRelacion] = useState([]);
  const [idRelacionPrincipal, setIdRelacionPrincipal] = useState(null);
  const [idTipoRelacionEdicion, setIdTipoRelacionEdicion] = useState("");
  const [modalEditarCabecera, setModalEditarCabecera] = useState(false);
  const getNowForInput = () => {
    const now = new Date();
    const pad = n => n.toString().padStart(2, '0');
    const yyyy = now.getFullYear();
    const MM = pad(now.getMonth() + 1);
    const dd = pad(now.getDate());
    const hh = pad(now.getHours());
    const mm = pad(now.getMinutes());
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
  };
  const [fechaControlManual, setFechaControlManual] = useState(getNowForInput());
  const [comorbilidadesSeleccionadas, setComorbilidadesSeleccionadas] = useState([]);
  const [todasComorbilidades, setTodasComorbilidades] = useState([]);
  const [modalComorbilidades, setModalComorbilidades] = useState(false);
  const [atributosSeleccionados, setAtributosSeleccionados] = useState([]);
  const [todosAtributos, setTodosAtributos] = useState([]);
  const [modalAtributos, setModalAtributos] = useState(false);
  const [diagnosticosDisponibles, setDiagnosticosDisponibles] = useState([]);
  const [diagnosticosSeleccionados, setDiagnosticosSeleccionados] = useState([]);
  const opcionesSexo = [
    { value: 'Masculino', label: 'Masculino' },
    { value: 'Femenino', label: 'Femenino' },
    { value: 'Otro', label: 'Otro' }
  ];
  const generosFijos = [
    'Desconocido',
    'Mujer cis',
    'Mujer trans',
    'Varón cis',
    'Varón trans',
    'Otro'
  ];
  const [generosDisponibles, setGenerosDisponibles] = useState(generosFijos);
  const { idPersona } = useParams();
  const navigate = useNavigate();
  const { patologiaActiva } = usePatologia();
  const [contacto, setContacto] = useState(null);
  const [comorbilidades, setComorbilidades] = useState([]);
  const [atributos, setAtributos] = useState("");
  const [relacionCaso, setRelacionCaso] = useState("");
  const [dynamicSintomas, setDynamicSintomas] = useState([]);
  const [sintomasValues, setSintomasValues] = useState({});
  const [observacionesSintomas, setObservacionesSintomas] = useState("");
  const [atributosPersonales, setAtributosPersonales] = useState([]);
  const [vacunas, setVacunas] = useState([]);
  const [medicaciones, setMedicaciones] = useState([]);
  const [estudios, setEstudios] = useState([]);
  const [vacunasSeleccionadas, setVacunasSeleccionadas] = useState({});
  const [medicacionesSeleccionadas, setMedicacionesSeleccionadas] = useState({});
  const [estudiosSeleccionados, setEstudiosSeleccionados] = useState({});
  const [tieneBCG, setTieneBCG] = useState(null);
  const [fechaBCG, setFechaBCG] = useState("");
  const [ultimaFechaControl, setUltimaFechaControl] = useState("");
  const [controlesPrevios, setControlesPrevios] = useState([]);
  const [peso, setPeso] = useState("");
  const [talla, setTalla] = useState("");
  const [intolerancias, setIntolerancias] = useState("");
  const [alergias, setAlergias] = useState("");
  const [loading, setLoading] = useState(true);

  // Estilo para botón volver (fijo)
  const backButtonStyle = {
    position: "fixed",
    top: "50%",
    left: 0,
    transform: "translateY(-50%)",
    height: "120px",
    width: "60px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#e3f2f9",
    boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.05)",
    cursor: "pointer",
    transition: "all 0.3s ease",
    zIndex: 500,
    borderRadius: "0 12px 12px 0",
    color: "#2a7fbd",
    fontWeight: 500,
    border: "none",
  };
  const backButtonHover = `
    .back-btn:hover {
      background: #d0e8f9;
      transform: translateX(-3px) translateY(-50%);
    }
  `;

  // --- FUNCIONES AUXILIARES ---
  const obtenerComorbilidades = async (personaId, patologiaId) => {
    if (!patologiaId) return;
    try {
      const response = await api.get(`comorbilidadesxpersonaxpatologia/${personaId}/${patologiaId}`);
      if (response.data && Array.isArray(response.data)) {
        const nombres = response.data.map(c => c.NombreComorbilidad).filter(Boolean);
        setComorbilidades(nombres);
      } else {
        setComorbilidades([]);
      }
    } catch (error) {
      setComorbilidades([]);
    }
  };

  const obtenerDiagnosticosDisponibles = async (patologiaId) => {
    if (!patologiaId) {
      setDiagnosticosDisponibles([]);
      return;
    }
    try {
      const response = await api.get(`diagnosticosPorPatologia/${patologiaId}`);
      const diagnosticosActivos = Array.isArray(response.data)
        ? response.data.filter(d => Number(d.estado) === 1)
        : [];
      setDiagnosticosDisponibles(diagnosticosActivos);
    } catch (error) {
      setDiagnosticosDisponibles([]);
    }
  };

  const obtenerDiagnosticosPersona = async (personaId, patologiaId) => {
    if (!personaId || !patologiaId) {
      setDiagnosticosSeleccionados([]);
      return;
    }
    try {
      const response = await api.get(`diagnosticosxpersonaxpatologia/${personaId}/${patologiaId}`);
      const ids = Array.isArray(response.data)
        ? response.data.map(d => Number(d.IdDiagnostico)).filter(Boolean)
        : [];
      setDiagnosticosSeleccionados(ids);
    } catch (error) {
      setDiagnosticosSeleccionados([]);
    }
  };

  const obtenerRelacionCaso = async (personaId) => {
    try {
      const response = await api.get(`relaciones/${personaId}`);
      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        const relacion = response.data[0];
        const nombreRelacionado = relacion.personaRelacionada
          ? `${relacion.personaRelacionada.nombre} ${relacion.personaRelacionada.apellido}`.trim()
          : "Persona desconocida";
        setRelacionCaso(`${relacion.tipoRelacion} del caso ${nombreRelacionado}`);
        setContacto(prev => ({
          ...prev,
          conviviente: relacion.conviviente ? "Sí" : "No"
        }));
        setIdRelacionPrincipal(relacion.idRelacion || null);
      } else {
        setRelacionCaso("Sin relación registrada");
      }
    } catch (error) {
      setRelacionCaso("Sin relación registrada");
    }
  };

  const abrirModalEditarCabecera = async () => {
    setDatosCabeceraEdicion({
      edad: contacto?.edad || '',
      sexo: contacto?.sexo || '',
      genero: contacto?.genero || '',
      conviviente: contacto?.conviviente === 'Sí' || contacto?.conviviente === true
    });
    try {
      const resp = await api.get('tiposRelacion');
      setTiposRelacion(Array.isArray(resp.data) ? resp.data : []);
      if (idRelacionPrincipal) {
        const relResp = await api.get(`relaciones/${idPersona}`);
        if (Array.isArray(relResp.data) && relResp.data.length > 0) {
          setIdTipoRelacionEdicion(relResp.data[0].idTipoRelacion || "");
        } else {
          setIdTipoRelacionEdicion("");
        }
      } else {
        setIdTipoRelacionEdicion("");
      }
    } catch (e) {
      setTiposRelacion([]);
      setIdTipoRelacionEdicion("");
    }
    setModalEditarCabecera(true);
  };

  const handleCambioCabecera = (campo, valor) => {
    setDatosCabeceraEdicion(prev => ({ ...prev, [campo]: valor }));
  };

  const guardarCabecera = async () => {
    try {
      const payload = {
        IdTipoDocumento: contacto?.IdTipoDocumento ?? 1,
        IdPais: contacto?.IdPais ?? 1,
        Email: contacto?.Email ?? '',
        Nombre: contacto?.nombre ?? '',
        Apellido: contacto?.apellido ?? '',
        Edad: datosCabeceraEdicion.edad !== '' ? datosCabeceraEdicion.edad : contacto?.edad ?? '',
        Sexo: datosCabeceraEdicion.sexo !== '' ? datosCabeceraEdicion.sexo : contacto?.sexo ?? '',
        NroDocumento: contacto?.dni ?? '',
        Genero: datosCabeceraEdicion.genero !== '' ? datosCabeceraEdicion.genero : contacto?.genero ?? ''
      };
      await api.patch(`personas/${idPersona}`, payload);
      if (idRelacionPrincipal !== null && typeof datosCabeceraEdicion.conviviente !== 'undefined') {
        await api.patch(`relaciones/${idRelacionPrincipal}/conviviente`, {
          conviviente: datosCabeceraEdicion.conviviente === true
        });
      }
      if (idRelacionPrincipal !== null && idTipoRelacionEdicion) {
        await api.patch(`relaciones/${idRelacionPrincipal}/tipoRelacion`, {
          idTipoRelacion: idTipoRelacionEdicion
        });
      }
      setContacto(prev => ({ ...prev }));
      await obtenerRelacionCaso(idPersona);
      setModalEditarCabecera(false);
      Swal.fire({ icon: 'success', title: 'Actualizado', text: 'Cabecera actualizada correctamente', timer: 1500, showConfirmButton: false });
    } catch (error) {
      console.error('Error al guardar cabecera:', error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo actualizar la cabecera' });
    }
  };

  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        const resp = await api.get(`seguimiento/persona/${idPersona}`);
        const personaData = resp.data;
        setContacto({
          idSeguimiento: personaData.idSeguimiento,
          nombre: personaData.nombre,
          dni: personaData.dni,
          edad: personaData.edad,
          sexo: personaData.sexo,
          genero: personaData.genero,
          conviviente: personaData.conviviente || "No",
          idCaso: personaData.IdCaso || personaData.idCaso || personaData.Caso || null,
          idPatologia: personaData.idPatologia || null
        });

        const pathologyId = personaData.idPatologia || patologiaActiva?.IdPatologia;
        if (!pathologyId) return;

        const respComorbilidades = await api.get(`comorbilidadesxpersonaxpatologia/${idPersona}/${pathologyId}`);
        if (respComorbilidades.data && Array.isArray(respComorbilidades.data)) {
          const idsComorbilidades = respComorbilidades.data.map(c => c.IdComorbilidad);
          setComorbilidadesSeleccionadas(idsComorbilidades);
        } else {
          setComorbilidadesSeleccionadas([]);
        }

        await obtenerComorbilidades(idPersona, pathologyId);
        await obtenerAtributos(idPersona, pathologyId);
        await obtenerDiagnosticosDisponibles(pathologyId);
        await obtenerDiagnosticosPersona(idPersona, pathologyId);
        await obtenerRelacionCaso(idPersona);

        try {
          if (personaData.idSeguimiento) {
            const controlesResp = await api.get(`controles/${personaData.idSeguimiento}`);
            setControlesPrevios(Array.isArray(controlesResp.data) ? controlesResp.data : []);
          } else {
            setControlesPrevios([]);
          }
        } catch (err) {
          setControlesPrevios([]);
        }

        const sintomasResp = await api.get(`sintomasporpatologia/${pathologyId}`);
        const sintomas = (sintomasResp.data || []).map(s => ({
          ...s,
          IdSintoma: s.IdSintomaPorPatologia,
          json_definicion:
            typeof s.json_definicion === "string"
              ? (() => { try { return JSON.parse(s.json_definicion); } catch { return { tipo: "texto" }; } })()
              : (s.json_definicion || { tipo: "texto" })
        }));
        setDynamicSintomas(sintomas);

        const vacunasResp = await api.get(`vacunas-por-patologia`);
        const vacunasFiltradas = (vacunasResp.data || [])
          .filter(v => v.IdPatologia === pathologyId && Number(v.estado) === 1);
        const vacunasConTipo = vacunasFiltradas.map(v => ({
          IdSintoma: v.IdVacunacionPorPatologia,
          Nombre: v.NombreVacuna || `Vacuna ${v.IdVacunacionPorPatologia}`,
          json_definicion:
            typeof v.json_definicion === "string"
              ? (() => { try { return JSON.parse(v.json_definicion); } catch { return { tipo: "booleano" }; } })()
              : (v.json_definicion || { tipo: "booleano" })
        }));
        setVacunas(vacunasConTipo);

        const medicacionesResp = await api.get(`medicaciones-por-patologia`);
        const medicacionesFiltradas = (medicacionesResp.data || [])
          .filter(m => m.IdPatologia === pathologyId && Number(m.estado) === 1);
        const medicacionesConTipo = medicacionesFiltradas.map(m => ({
          IdSintoma: m.IdMedicacionPorPatologia,
          Nombre: m.NombreMedicacion || `Medicación ${m.IdMedicacionPorPatologia}`,
          json_definicion:
            typeof m.json_definicion === "string"
              ? (() => { try { return JSON.parse(m.json_definicion); } catch { return { tipo: "booleano" }; } })()
              : (m.json_definicion || { tipo: "booleano" })
        }));
        setMedicaciones(medicacionesConTipo);

        const estudiosResp = await api.get(`estudios-patologia/${pathologyId}`);
        const estudiosConTipo = (estudiosResp.data || [])
          .filter(e => Number(e.estadoRelacion) === 1)
          .map(e => {
            let jsonDef = e.json_definicion;
            if (typeof jsonDef === 'string') {
              try {
                jsonDef = JSON.parse(jsonDef);
              } catch (err) {
                console.error('Error parseando json_definicion de estudio:', e.Nombre, err);
                jsonDef = { tipo: "texto" };
              }
            }
            if (!jsonDef || Object.keys(jsonDef).length === 0) {
              jsonDef = { tipo: "texto" };
            }
            return {
              IdSintoma: e.IdEstudio,
              Nombre: e.Nombre,
              json_definicion: typeof jsonDef === 'string' ? jsonDef : JSON.stringify(jsonDef)
            };
          });
        setEstudios(estudiosConTipo);

        const inicializarValores = (campos) => {
          const vals = {};
          campos.forEach(f => {
            const definicion = typeof f.json_definicion === "object" ? f.json_definicion : JSON.parse(f.json_definicion);
            if (definicion.tipo === "booleano") vals[f.IdSintoma] = false;
            else if (definicion.tipo === "multiple") vals[f.IdSintoma] = [];
            else if (definicion.tipo === "compuesto") vals[f.IdSintoma] = {};
            else vals[f.IdSintoma] = "";
          });
          return vals;
        };

        setSintomasValues(inicializarValores(sintomas));
        setVacunasSeleccionadas(inicializarValores(vacunasConTipo));
        setMedicacionesSeleccionadas(inicializarValores(medicacionesConTipo));
        setEstudiosSeleccionados(inicializarValores(estudiosConTipo));

      } catch (err) {
        console.error("Error cargando datos:", err);
      } finally {
        setLoading(false);
      }
    };

    obtenerDatos();
  }, [idPersona, patologiaActiva]);

  const obtenerAtributos = async (personaId, patologiaId) => {
    try {
      const resp = await api.get(`atributosxpersonaxpatologia/${personaId}/${patologiaId}`);
      if (Array.isArray(resp.data) && resp.data.length > 0) {
        const nombres = resp.data.map(a => a.Atributo?.Nombre).filter(Boolean);
        setAtributos(nombres.join(" - "));
      } else {
        setAtributos("");
      }
    } catch (err) {
      console.error("Error obteniendo atributos:", err);
      setAtributos("");
    }
  };

  const handleSintomaValueChange = (id, val) =>
    setSintomasValues(prev => ({ ...prev, [id]: val }));
  const handleVacunaChange = (id, val) =>
    setVacunasSeleccionadas(prev => ({ ...prev, [id]: val }));
  const handleMedicacionChange = (id, val) =>
    setMedicacionesSeleccionadas(prev => ({ ...prev, [id]: val }));
  const handleEstudioChange = (id, val) =>
    setEstudiosSeleccionados(prev => ({ ...prev, [id]: val }));

  const abrirModalComorbilidades = async () => {
    try {
      const idPatologia = contacto?.idPatologia;
      if (!idPatologia) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró la patología asociada" });
        return;
      }
      const resp = await api.get(`comorbilidades/${idPatologia}`);
      setTodasComorbilidades(resp.data.filter(c => c.estado === 1));
      const respActuales = await api.get(`comorbilidadesxpersonaxpatologia/${idPersona}/${idPatologia}`);
      const idsActuales = respActuales.data.map(c => c.IdComorbilidad);
      setComorbilidadesSeleccionadas(idsActuales);
      setModalComorbilidades(true);
    } catch (error) {
      console.error("Error cargando comorbilidades:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar las comorbilidades" });
    }
  };

  const guardarComorbilidades = async () => {
    try {
      const idPatologia = contacto?.idPatologia;
      if (!idPatologia) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró la patología asociada" });
        return;
      }
      await api.post('comorbilidadesxpersonaxpatologia', {
        IdPersona: parseInt(idPersona),
        IdPatologia: idPatologia,
        comorbilidades: comorbilidadesSeleccionadas
      });
      await obtenerComorbilidades(idPersona, idPatologia);
      setModalComorbilidades(false);
      Swal.fire({ icon: "success", title: "Guardado", text: "Comorbilidades actualizadas correctamente", timer: 1500, showConfirmButton: false });
    } catch (error) {
      console.error("Error guardando comorbilidades:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron guardar las comorbilidades" });
    }
  };

  const toggleComorbilidad = (idComorbilidad) => {
    setComorbilidadesSeleccionadas(prev => {
      if (prev.includes(idComorbilidad)) {
        return prev.filter(id => id !== idComorbilidad);
      } else {
        return [...prev, idComorbilidad];
      }
    });
  };

  const abrirModalAtributos = async () => {
    try {
      const idPatologia = contacto?.idPatologia;
      if (!idPatologia) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró la patología asociada" });
        return;
      }
      const resp = await api.get(`atributosPorPatologia/${idPatologia}`);
      setTodosAtributos(resp.data.filter(a => a.estado === 1));
      const respActuales = await api.get(`atributosxpersonaxpatologia/${idPersona}/${idPatologia}`);
      const idsActuales = respActuales.data.map(a => a.IdAtributo);
      setAtributosSeleccionados(idsActuales);
      setModalAtributos(true);
    } catch (error) {
      console.error("Error cargando atributos:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar los atributos" });
    }
  };

  const guardarAtributos = async () => {
    try {
      const idPatologia = contacto?.idPatologia;
      if (!idPatologia) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró la patología asociada" });
        return;
      }
      await api.post('atributosxpersonaxpatologia', {
        IdPersona: parseInt(idPersona),
        IdPatologia: idPatologia,
        atributos: atributosSeleccionados
      });
      await obtenerAtributos(idPersona, idPatologia);
      setModalAtributos(false);
      Swal.fire({ icon: "success", title: "Guardado", text: "Atributos actualizados correctamente", timer: 1500, showConfirmButton: false });
    } catch (error) {
      console.error("Error guardando atributos:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron guardar los atributos" });
    }
  };

  const toggleAtributo = (idAtributo) => {
    setAtributosSeleccionados(prev => {
      if (prev.includes(idAtributo)) {
        return prev.filter(id => id !== idAtributo);
      } else {
        return [...prev, idAtributo];
      }
    });
  };

  const guardarSeguimiento = async () => {
    if (!contacto?.idSeguimiento) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se encontró el seguimiento asociado a la persona.' });
      return;
    }
    if (!fechaControlManual) {
      Swal.fire({ icon: 'warning', title: 'Fecha requerida', text: 'Por favor ingresá la fecha y hora del control.' });
      return;
    }
    const fechaControl = new Date(fechaControlManual).toISOString();
    const numeroControl = (controlesPrevios?.length || 0) + 1;

    const json_datos = {
      sintomas: sintomasValues,
      observacionesSintomas,
      vacunas: vacunasSeleccionadas,
      medicaciones: medicacionesSeleccionadas,
      estudios: estudiosSeleccionados,
      datosAntropometricos: {
        peso,
        talla,
        intolerancias,
        alergias
      }
    };

    try {
      const response = await api.post('controles', {
        idSeguimiento: contacto.idSeguimiento,
        numeroControl,
        fechaControl,
        observaciones: observacionesSintomas,
        json_datos,
        idPatologia: contacto.idPatologia || (patologiaActiva && patologiaActiva.IdPatologia) || null
      });

      const idPatologiaDiagnostico = contacto.idPatologia || (patologiaActiva && patologiaActiva.IdPatologia) || null;
      if (idPatologiaDiagnostico) {
        await api.post('diagnosticosxpersonaxpatologia', {
          IdPersona: Number(idPersona),
          IdPatologia: Number(idPatologiaDiagnostico),
          diagnosticos: diagnosticosSeleccionados.map(Number)
        });
      }

      if (response.data?.evaluacionReglas?.reglasActivadas?.length > 0) {
        const reglas = response.data.evaluacionReglas.reglasActivadas;
        let mensaje = '<div style="text-align: left;"><strong>Se activaron las siguientes reglas:</strong><br/><br/>';
        reglas.forEach((regla, index) => {
          const mensajeRegla =
            regla.Json_Definicion?.mensaje ||
            regla.Json_Definicion?.Mensaje ||
            regla.Json_Definicion?.accion ||
            regla.Json_Definicion?.Accion ||
            regla.Accion ||
            regla.Mensaje ||
            regla.mensaje ||
            'Sin mensaje definido';
          mensaje += `<div style=\"margin-bottom: 10px; padding: 10px; background: #f8f9fa; border-left: 4px solid #ff9800; border-radius: 4px;\">\n            <strong>${index + 1}. ${regla.Nombre}</strong><br/>\n            <span style=\"color: #666;\">${regla.Descripcion || regla.descripcion || ''}</span><br/>\n            <strong style=\"color: #d32f2f;\">Alerta:</strong> ${mensajeRegla}\n          </div>`;
        });
        mensaje += '</div>';
        await Swal.fire({
          icon: "warning",
          title: "Alerta de reglas",
          html: mensaje,
          width: 600,
          confirmButtonText: "Entendido",
          confirmButtonColor: "#d32f2f"
        });
      } else {
        await Swal.fire({ icon: 'success', title: 'Control guardado', timer: 1200, showConfirmButton: false });
      }

      try {
        const reglasResp = await api.get('reglas');
        const reglas = Array.isArray(reglasResp.data) ? reglasResp.data : [];
        const reglasRelacion = reglas.filter(r =>
          (r.campo === 'relacion' || r.categoria === 'relacion')
        );
        let valorRelacionCabecera = '';
        if (relacionCaso && typeof relacionCaso === 'string') {
          valorRelacionCabecera = relacionCaso.split(' del caso')[0].trim();
        }
        const normalizar = v => (v || '').toString().trim().toLowerCase().normalize('NFD').replace(/[\u0000-\u036f]/g, '');
        const reglasCoincidentes = reglasRelacion.filter(r => {
          const valorRegla = r.valor || r.valorCondicion || r.condicion || '';
          const operador = r.operador || r.operadorCondicion || r.operadorComparacion || '';
          const valCab = normalizar(valorRelacionCabecera);
          const valRegla = normalizar(valorRegla);
          if (operador === 'like') {
            return valCab && valRegla && valCab.includes(valRegla);
          } else {
            return valCab && valRegla && valCab === valRegla;
          }
        });
        if (reglasCoincidentes.length > 0) {
          let mensaje = '<div style="text-align: left;"><strong>Se activaron reglas por Relación con el caso:</strong><br/><br/>';
          reglasCoincidentes.forEach((regla, index) => {
            mensaje += `<div style="margin-bottom: 10px; padding: 10px; background: #f8f9fa; border-left: 4px solid #2196f3; border-radius: 4px;">
              <strong>${index + 1}. ${regla.nombre || regla.Nombre || 'Regla'}</strong><br/>
              <span style="color: #666;">${regla.descripcion || regla.Descripcion || ''}</span><br/>
              <strong style="color: #1976d2;">Mensaje:</strong> ${regla.mensaje || regla.Mensaje || regla.accion || regla.Accion || ''}
            </div>`;
          });
          mensaje += '</div>';
          await Swal.fire({
            icon: "info",
            title: "Alerta de relación con el caso",
            html: mensaje,
            width: 600,
            confirmButtonText: "Entendido",
            confirmButtonColor: "#1976d2"
          });
        }
      } catch (e) {
        console.error('Error verificando reglas de relación con el caso:', e);
      }

      const controlesResp = await api.get(`controles/${contacto.idSeguimiento}`);
      setControlesPrevios(Array.isArray(controlesResp.data) ? controlesResp.data : []);

      navigate(`/PrivateMainPage/ControlSeguimiento/${idPersona}`);
    } catch (err) {
      console.error('Error guardando control:', err);
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo guardar el control' });
    }
  }

  if (loading) return <div className="seguimiento-container"><div className="seguimiento-card">Cargando seguimiento...</div></div>;
  if (!contacto) return <div className="seguimiento-container"><div className="seguimiento-card">No se encontró información del contacto.</div></div>;

  return (
    <>
      <div className="seguimiento-container">
        <style>{backButtonHover}</style>
        <button style={backButtonStyle} className="back-btn" onClick={() => window.history.back()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          <span>Volver</span>
        </button>

        <div className="seguimiento-card seguimiento-card-ancha">
          {contacto.idCaso && (
            <div className="seguimiento-caso-bar">
              Caso de origen: <span style={{ fontWeight: 800 }}>{contacto.idCaso}</span>
            </div>
          )}
          <header className="seguimiento-header seguimiento-header-ancha seguimiento-header-pro">
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px', minWidth: 0 }}>
              <div style={{ fontWeight: 500, fontSize: '16px', color: '#6b6b6b', marginBottom: '2px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                Relación con el caso: <span style={{ fontWeight: 400 }}>{relacionCaso || 'Sin relación registrada'}</span>
              </div>
              <div style={{ fontWeight: 600, fontSize: '19px', color: '#222', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                Seguimiento del contacto:
                <span style={{ fontWeight: 700, fontSize: '22px', color: '#222', marginLeft: '8px' }}>{contacto.nombre}</span>
                {contacto.idCaso && (
                  <span style={{ fontWeight: 500, fontSize: '16px', color: '#0fb9b1', marginLeft: '18px', background: '#e8f8f7', borderRadius: '8px', padding: '3px 12px', display: 'inline-block' }}>
                    Caso: {contacto.idCaso}
                  </span>
                )}
              </div>
              <div style={{ marginBottom: '6px', lineHeight: 1.7, fontSize: '16px', color: '#444', display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                <span>DNI: <span style={{ color: '#555' }}>{contacto.dni}</span></span>
                <span><span style={{ fontSize: '17px', color: '#bdbdbd', marginRight: '2px' }}></span>Edad: <span style={{ color: '#555' }}>{contacto.edad}</span></span>
                <span>Sexo: <span style={{ color: '#555' }}>{contacto.sexo}</span></span>
                <span>Género: <span style={{ color: '#555' }}>{contacto.genero}</span></span>
                <span>Conviviente: <span style={{ color: '#555' }}>{contacto.conviviente}</span></span>
              </div>
              <div style={{ marginBottom: 0, fontSize: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontWeight: 500 }}>Comorbilidad:</span> <span style={{ color: '#555', marginRight: '12px' }}>{comorbilidades.length > 0 ? comorbilidades.join(' - ') : 'No se registran comorbilidades'}</span>
              </div>
              <div style={{ marginBottom: 0, fontSize: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontWeight: 500 }}>Atributos Personales:</span> <span style={{ color: '#555', marginRight: '12px' }}>{atributos || 'No se registran atributos'}</span>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0' }}>
              <div className="seguimiento-header-actions">
                <button className="seguimiento-btn-main seguimiento-btn-verde seguimiento-btn-pro" onClick={abrirModalEditarCabecera} title="Editar cabecera">
                  <span>Cabecera</span>
                </button>
                <button className="seguimiento-btn-outline seguimiento-btn-verde seguimiento-btn-pro" onClick={abrirModalComorbilidades} title="Editar Comorbilidades">
                  <span>Comorbilidad</span>
                </button>
                <button className="seguimiento-btn-outline seguimiento-btn-verde seguimiento-btn-pro" onClick={abrirModalAtributos} title="Editar Atributos">
                  <span>Atributos</span>
                </button>
              </div>
            </div>
          </header>

          {/* Sección de fecha y hora (integrada como parte de la cartilla) */}
          <section className="seguimiento-card-datos mejorada">
            <div className="seguimiento-datos-row">
              <div className="seguimiento-dato-item">
                <label>Fecha y hora</label>
                <input type="datetime-local" value={fechaControlManual} onChange={e => setFechaControlManual(e.target.value)} required />
              </div>
              <div className="seguimiento-dato-item">
                <label>Estado</label>
                <span>{contacto?.estado || 'Sin estado'}</span>
              </div>
              <div className="seguimiento-dato-item">
                <label>Diagnóstico</label>
                <div className="seguimiento-diagnostico-checkbox-list">
                  {diagnosticosDisponibles.length === 0 ? (
                    <div className="seguimiento-diagnostico-empty">Sin diagnósticos para la patología activa</div>
                  ) : (
                    diagnosticosDisponibles.map((d) => {
                      const idDiag = Number(d.IdDiagnostico);
                      const checked = diagnosticosSeleccionados.includes(idDiag);
                      return (
                        <label key={idDiag} className="seguimiento-diagnostico-checkbox-item">
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => {
                              setDiagnosticosSeleccionados((prev) => (
                                checked ? prev.filter((id) => id !== idDiag) : [...prev, idDiag]
                              ));
                            }}
                          />
                          <span>{d.NombreDiagnostico || d.Nombre || `Diagnóstico ${idDiag}`}</span>
                        </label>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
            <div className="seguimiento-datos-underline"></div>
          </section>

          {/* Modal Editar Cabecera */}
          {modalEditarCabecera && (
            <div className="modal is-active">
              <div className="modal-background" onClick={() => setModalEditarCabecera(false)}></div>
              <div className="modal-card" style={{ maxWidth: "600px", maxHeight: "90vh" }}>
                <header className="modal-card-head" style={{ width: "100%" }}>
                  <p className="modal-card-title">Editar Cabecera</p>
                  <button className="delete" aria-label="close" onClick={() => setModalEditarCabecera(false)}></button>
                </header>
                <section className="modal-card-body" style={{ maxHeight: "calc(90vh - 150px)", overflowY: "auto" }}>
                  <div className="field">
                    <label className="label">Edad</label>
                    <div className="control">
                      <input className="input" type="number" value={datosCabeceraEdicion.edad} onChange={e => handleCambioCabecera('edad', e.target.value)} />
                    </div>
                  </div>
                  <div className="field">
                    <label className="label">Sexo</label>
                    <div className="control">
                      <select className="input" value={datosCabeceraEdicion.sexo} onChange={e => handleCambioCabecera('sexo', e.target.value)}>
                        <option value="">Seleccione...</option>
                        {opcionesSexo.map(opt => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="field">
                    <label className="label">Género</label>
                    <div className="control">
                      <select className="input" value={datosCabeceraEdicion.genero} onChange={e => handleCambioCabecera('genero', e.target.value)}>
                        <option value="">Seleccione...</option>
                        {generosDisponibles.map(g => (
                          <option key={g} value={g}>{g}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="field">
                    <label className="label">Tipo de Relación con el caso</label>
                    <div className="control">
                      <select
                        className="input"
                        value={idTipoRelacionEdicion}
                        onChange={e => setIdTipoRelacionEdicion(e.target.value)}
                      >
                        <option value="">Seleccione...</option>
                        {tiposRelacion.length === 0 && (
                          <option value="" disabled>
                            (No hay opciones disponibles)
                          </option>
                        )}
                        {tiposRelacion.map(tipo => (
                          <option key={tipo.idTipoRelacion} value={tipo.idTipoRelacion}>
                            {tipo.nombre}
                          </option>
                        ))}
                      </select>
                      {tiposRelacion.length === 0 && (
                        <div style={{ color: 'red', marginTop: 6, fontSize: 14 }}>
                          No hay tipos de relación disponibles. Verifique la configuración o la respuesta del servidor.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="field">
                    <label className="label">Conviviente</label>
                    <div className="control" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <input
                        type="checkbox"
                        checked={datosCabeceraEdicion.conviviente === true}
                        onChange={e => handleCambioCabecera('conviviente', e.target.checked)}
                      />
                      <span>{datosCabeceraEdicion.conviviente ? 'Sí' : 'No'}</span>
                    </div>
                  </div>
                </section>
                <footer className="modal-card-foot">
                  <button className="button is-success" onClick={guardarCabecera}>Guardar Cambios</button>
                  <button className="button" onClick={() => setModalEditarCabecera(false)}>Cancelar</button>
                </footer>
              </div>
            </div>
          )}

          {/* Grid de tarjetas (2 columnas) */}
          <div className="seguimiento-grid-cards">
            {/* Síntomas */}
            <div className="seguimiento-section-card">
              <h3>Síntomas</h3>
              <div className="seguimiento-dynamic-fields-grid">
                {dynamicSintomas.map(s => (
                  <RenderField key={s.IdSintoma} field={s} value={sintomasValues[s.IdSintoma]} onChange={handleSintomaValueChange} />
                ))}
              </div>
              <div className="seguimiento-field">
                <label>Observaciones generales</label>
                <textarea className="seguimiento-textarea" value={observacionesSintomas} onChange={e => setObservacionesSintomas(e.target.value)} rows={3} />
              </div>
            </div>

            {/* Vacunas */}
            <div className="seguimiento-section-card">
              <h3>Vacunas</h3>
              <div className="seguimiento-dynamic-fields-grid">
                {vacunas.map(v => (
                  <RenderField key={v.IdSintoma} field={v} value={vacunasSeleccionadas[v.IdSintoma]} onChange={handleVacunaChange} />
                ))}
              </div>
            </div>

            {/* Tratamiento */}
            <div className="seguimiento-section-card">
              <h3>Tratamiento</h3>
              <div className="seguimiento-dynamic-fields-grid">
                {medicaciones.map(m => (
                  <RenderField key={m.IdSintoma} field={m} value={medicacionesSeleccionadas[m.IdSintoma]} onChange={handleMedicacionChange} />
                ))}
              </div>
              <div className="seguimiento-grid-2">
                <div className="seguimiento-field">
                  <label>Intolerancias</label>
                  <textarea placeholder="Ej: lactosa, gluten..." value={intolerancias} onChange={e => setIntolerancias(e.target.value)} rows={2} />
                </div>
                <div className="seguimiento-field">
                  <label>Alergias</label>
                  <textarea placeholder="Ej: penicilina, polen..." value={alergias} onChange={e => setAlergias(e.target.value)} rows={2} />
                </div>
              </div>
            </div>

            {/* Datos antropométricos */}
            <div className="seguimiento-section-card">
              <h3>Datos antropométricos</h3>
              <div className="seguimiento-grid-2">
                <div className="seguimiento-field">
                  <label>Peso (kg)</label>
                  <input type="number" step="0.1" value={peso} onChange={e => setPeso(e.target.value)} />
                </div>
                <div className="seguimiento-field">
                  <label>Talla (cm)</label>
                  <input type="number" step="0.1" value={talla} onChange={e => setTalla(e.target.value)} />
                </div>
              </div>
            </div>

            {/* Estudios (ocupa ambas columnas) */}
            <div className="seguimiento-section-card seguimiento-full-width">
              <h3>Estudios</h3>
              <div className="seguimiento-dynamic-fields-grid">
                {estudios.map(e => (
                  <RenderField key={e.IdSintoma} field={e} value={estudiosSeleccionados[e.IdSintoma]} onChange={handleEstudioChange} />
                ))}
              </div>
            </div>
          </div>

          <footer className="seguimiento-actions">
            <button className="seguimiento-button seguimiento-button--success" onClick={guardarSeguimiento}>Guardar</button>
            <button className="seguimiento-button seguimiento-button--danger" onClick={() => window.history.back()}>Cancelar</button>
          </footer>
        </div>

        {/* Modal de Comorbilidades */}
        {modalComorbilidades && (
          <div className="modal is-active">
            <div className="modal-background" onClick={() => setModalComorbilidades(false)}></div>
            <div className="modal-card" style={{ maxWidth: "600px" }}>
              <header className="modal-card-head">
                <p className="modal-card-title">Editar Comorbilidades</p>
                <button className="delete" aria-label="close" onClick={() => setModalComorbilidades(false)}></button>
              </header>
              <section className="modal-card-body">
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {todasComorbilidades.filter(c => c.estado === 1).map(comorbilidad => (
                    <label key={comorbilidad.IdComorbilidad} style={{ display: "block", padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee" }}>
                      <input type="checkbox" checked={comorbilidadesSeleccionadas.includes(comorbilidad.IdComorbilidad)} onChange={() => toggleComorbilidad(comorbilidad.IdComorbilidad)} style={{ marginRight: "10px" }} />
                      {comorbilidad.Nombre}
                      {comorbilidad.Descripcion && <span style={{ color: "#666", fontSize: "12px", display: "block", marginLeft: "24px" }}>{comorbilidad.Descripcion}</span>}
                    </label>
                  ))}
                </div>
              </section>
              <footer className="modal-card-foot">
                <button className="button is-success" onClick={guardarComorbilidades}>Guardar</button>
                <button className="button" onClick={() => setModalComorbilidades(false)}>Cancelar</button>
              </footer>
            </div>
          </div>
        )}

        {/* Modal de Atributos */}
        {modalAtributos && (
          <div className="modal is-active">
            <div className="modal-background" onClick={() => setModalAtributos(false)}></div>
            <div className="modal-card" style={{ maxWidth: "600px" }}>
              <header className="modal-card-head">
                <p className="modal-card-title">Editar Atributos Personales</p>
                <button className="delete" aria-label="close" onClick={() => setModalAtributos(false)}></button>
              </header>
              <section className="modal-card-body">
                <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {todosAtributos.length === 0 ? (
                    <p style={{ textAlign: "center", color: "#999", padding: "20px" }}>No hay atributos disponibles para esta patología</p>
                  ) : (
                    todosAtributos.map(atributo => (
                      <label key={atributo.IdAtributo} style={{ display: "block", padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee" }}>
                        <input type="checkbox" checked={atributosSeleccionados.includes(atributo.IdAtributo)} onChange={() => toggleAtributo(atributo.IdAtributo)} style={{ marginRight: "10px" }} />
                        {atributo.NombreAtributo || atributo.Nombre}
                        {atributo.Descripcion && <span style={{ color: "#666", fontSize: "12px", display: "block", marginLeft: "24px" }}>{atributo.Descripcion}</span>}
                      </label>
                    ))
                  )}
                </div>
              </section>
              <footer className="modal-card-foot">
                <button className="button is-success" onClick={guardarAtributos}>Guardar</button>
                <button className="button" onClick={() => setModalAtributos(false)}>Cancelar</button>
              </footer>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Seguimiento;